import { render, staticRenderFns } from "./CustomDiaryIconButton.vue?vue&type=template&id=898893d0&scoped=true"
import script from "./CustomDiaryIconButton.vue?vue&type=script&lang=js"
export * from "./CustomDiaryIconButton.vue?vue&type=script&lang=js"
import style0 from "./CustomDiaryIconButton.vue?vue&type=style&index=0&id=898893d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898893d0",
  null
  
)

export default component.exports